/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_ProsInputs */

const en_fc_home_review_pros = /** @type {(inputs: Fc_Home_Review_ProsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strengths`)
};

/**
* | output |
* | --- |
* | "Strengths" |
*
* @param {Fc_Home_Review_ProsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_pros = /** @type {((inputs?: Fc_Home_Review_ProsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_ProsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_pros(inputs)
});
export { fc_home_review_pros as "fc.home.review.pros" }